// extracted by mini-css-extract-plugin
module.exports = {"aside":"AsideText_aside__25uOs","asideText":"AsideText_asideText__2oDuP"};